import React from 'react'
import { connect } from 'react-redux'

import Step3View from './Step3View'

const Step3Sms = ({ isFetching, currentTemplate, company, variables, options, templates }) => (
  <Step3View
    info={{
      name: 'SMS',
      channel: 'SMS',
    }}
    isFetching={isFetching}
    currentTemplate={currentTemplate}
    company={company}
    variables={variables}
    options={options}
    templates={templates}
  />
)

export default connect()(Step3Sms)
